import { ActCard } from "components/GlobalComponents/ActCard/ActCard";
import { getTranslatedField } from "helpers";
import { objectKeysToLowerCase } from "helpers/objectKeysToLowerCase";
import React from "react";
import { useTranslation } from "react-i18next";
import "./TabelaAkteve.scss";

export const TabelaAkteve = ({ akte, t }) => {
  const { i18n } = useTranslation();
  let transformetKeysArr = akte?.map((item) => objectKeysToLowerCase(item));
  // Sort by datemiratimi (if exists), else by datedepozitimi, descending
  transformetKeysArr = transformetKeysArr?.slice().sort((a, b) => {
    const dateA = a.datemiratimi || a.datedepozitimi;
    const dateB = b.datemiratimi || b.datedepozitimi;
    if (!dateA && !dateB) return 0;
    if (!dateA) return 1;
    if (!dateB) return -1;
    return new Date(dateB) - new Date(dateA);
  });
  return (
    <div className="akte-wrapper">
      {transformetKeysArr.map((akt, key) => (
        <ActCard
          key={key}
          id={akt.id}
          title={getTranslatedField(akt, i18n, "titull", "titullEn")}
          // number="123"
          propozuesi={akt.propozuesi}
          time={{
            dt_dep: akt.datedepozitimi,
            dt_miratimi: akt.datemiratimi,
          }}
          Date_Miratimi={akt.datemiratimi}
          type={akt.tip}
          t={t}
        />
      ))}
    </div>
  );
};

export default TabelaAkteve;
